import { render, staticRenderFns } from "./SelectOrderOption.vue?vue&type=template&id=4f1c954f&scoped=true&"
import script from "./SelectOrderOption.vue?vue&type=script&lang=js&"
export * from "./SelectOrderOption.vue?vue&type=script&lang=js&"
import style0 from "./SelectOrderOption.vue?vue&type=style&index=0&id=4f1c954f&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f1c954f",
  null
  
)

export default component.exports